import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "../../images/logo/mandoobee.png";
import { useTheme } from "../../components/Theme/Themecontext";
import LoadingButton from "../../components/LoadingButton";

const ForgetPassword = () => {
  const { t } = useTranslation();
  const { styles } = useTheme();
  const { input, bluetext } = styles;
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [validation, setValidation] = useState({
    email: "",
  });

  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true)

    const errors = {};
    if (!email) errors.email = "Please enter a email ";

    if (Object.keys(errors).length > 0) {
      setValidation(errors);
      setIsSubmitting(false)
      return;
    }
    try {
      const response = await fetch(`${baseUrl}/resetPassword?email=${email}`, {
        method: "GET",
      });

      if (response.status === 200) {
        const data = await response.json();
        setMessage(data.message);
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    } catch (err) {
      setError("Failed to connect to the server. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className=" w-full h-screen flex flex-col justify-center items-center p-2 md:p-5">
        <div className=" grid grid-cols-1 lg:grid-cols-2  gap-5 items-center justify-center">
          <div className=" w-full mb-3 ">
            <img
              className="h-[100px] w-full  mt-3"
              src={logo}
              alt=""
              data-csiid="12"
              data-atf="1"
            />
          </div>
          <div className="flex w-full items-center justify-center  ">
            <form className="flex flex-col w-full items-center justify-center">
              <h1 className="font-bold text-[18px] text-center">
                Forget Password
              </h1>
              <p className=" text-[16px] text-center mb-3 md:mb-0">
                Reset my password via email address
              </p>
              <div className="w-full">
                <label htmlFor="">
                  Email Address
                  <span className=" text-red-500 ml-1">*</span>
                </label>
                <input
                  className={`w-full px-3 py-4 rounded-lg  text-[12px] md:text-[14px] outline-none ${styles.placeholderclassName}`}
                  type="email"
                  name="email"
                  style={input}
                  placeholder="enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <span className="text-[12px] text-red-600 block mt-1">
                  {validation.email}
                </span>
              </div>

              {/* onSubmit={handleSubmit} */}
              <LoadingButton
                onClick={handleSubmit}
                loading={isSubmitting}
                className=" w-full bg-[#1552B2] text-white"
              >
                {t("submit")}
              </LoadingButton>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
